import React from 'react';
import { IntlShape } from 'react-intl';
import messages from './messages.json';
import LinkAndAnchor from '../components/LinkAndAnchor';

const renderMailto = (
  address: string,
  chunks: React.ReactNode,
) => (
  React.createElement(
    'a',
    { href: `mailto:${address}` },
    chunks,
  )
);

const renderRoute = (
  route: string,
  chunks: React.ReactNode,
) => (
  React.createElement(
    LinkAndAnchor,
    { route, hoverUnderline: true },
    chunks,
  )
);

const renderHref = (
  href: string,
  chunks: React.ReactNode,
) => (
  React.createElement(
    LinkAndAnchor,
    {
      href,
      useRouter: false,
      target: '_blank',
      rel: 'noopener noreferrer',
      hoverUnderline: true,
    },
    chunks,
  )
);

const contactFaq = (intl: IntlShape) => ([
  {
    id: 'contact-common-questions',
    items: [
      {
        id: 'brand-or-wholesaler',
        question: intl.formatMessage(
          messages['messages.contact.faq.brandOrWholesaler.question'],
        ),
        answer: intl.formatMessage(
          messages['messages.contact.faq.brandOrWholesaler.answer'],
          {
            strong: (chunks: React.ReactNode) => (
              React.createElement('strong', null, chunks)
            ),
            link: (chunks: React.ReactNode) => (
              renderRoute('brands-directory', chunks)
            ),
          },
        ),
      },
      {
        id: 'job-application',
        question: intl.formatMessage(
          messages['messages.contact.faq.jobApplication.question'],
        ),
        answer: intl.formatMessage(
          messages['messages.contact.faq.jobApplication.answer'],
        ),
      },
      {
        id: 'sell-to-us',
        question: intl.formatMessage(
          messages['messages.contact.faq.sellToUs.question'],
        ),
        answer: intl.formatMessage(
          messages['messages.contact.faq.sellToUs.answer'],
          {
            email: (chunks: React.ReactNode) => (
              renderMailto('media@fashionunited.com', chunks)
            ),
          },
        ),
      },
      {
        id: 'post-a-job',
        question: intl.formatMessage(
          messages['messages.contact.faq.postAJob.question'],
        ),
        answer: intl.formatMessage(
          messages['messages.contact.faq.postAJob.answer'],
          {
            link: (chunks: React.ReactNode) => (
              renderHref('https://dashboard.fashionunited.com', chunks)
            ),
            email: (chunks: React.ReactNode) => (
              renderMailto('jobs@fashionunited.com', chunks)
            ),
          },
        ),
      },
      {
        id: 'press-release',
        question: intl.formatMessage(
          messages['messages.contact.faq.pressRelease.question'],
        ),
        answer: intl.formatMessage(
          messages['messages.contact.faq.pressRelease.answer'],
          {
            newsEmail: (chunks: React.ReactNode) => renderMailto(
              'news@fashionunited.com',
              chunks,
            ),
            mediaEmail: (chunks: React.ReactNode) => renderMailto(
              'media@fashionunited.com',
              chunks,
            ),
          },
        ),
      },
    ],
  },
]);

export default contactFaq;
